import ActionsMenu, {
    ActionsMenuProps,
} from '../../common/Navigation/ActionsMenu';
import KeyManagementGenerateCertificateButton from './KeyManagementGenerateCertificateButton';
import KeyManagementImportCertificateButton from './KeyManagementImportCertificateButton';
import {FormOutlined, ImportOutlined} from "@ant-design/icons";

export default KeyManagementGenerateActionMenu;

export type KeyManagementGenerateActionMenuProps = ActionsMenuProps & {
    list: any;
    onActionPerformed: () => void;
};

function KeyManagementGenerateActionMenu({
    list,
    onActionPerformed,
}: KeyManagementGenerateActionMenuProps) {
    return (
        <ActionsMenu
            items={[
                {
                    key: 'generate-key-1',
                    icon: <FormOutlined />,
                    label: (
                        <KeyManagementGenerateCertificateButton
                            clientServer={false}
                            list={list}
                            onSuccess={onActionPerformed}
                        />
                    ),
                },
                {
                    key: 'generate-key-2',
                    icon: <FormOutlined />,
                    label: (
                        <KeyManagementGenerateCertificateButton
                            clientServer={true}
                            list={list}
                            onSuccess={onActionPerformed}
                        />
                    ),
                },
                {
                    key: 'import-key',
                    icon: <ImportOutlined />,
                    label: (
                        <KeyManagementImportCertificateButton
                            onSuccess={onActionPerformed}
                            list={list}
                        />
                    ),
                },
            ]}
        />
    );
}
